import { render, staticRenderFns } from "./ChatRecodSearchFansComp.vue?vue&type=template&id=3a36d9b8&"
import script from "./ChatRecodSearchFansComp.vue?vue&type=script&lang=js&"
export * from "./ChatRecodSearchFansComp.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecodSearchFansComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports